// src/slices/villageSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedVillageId: localStorage.getItem('VillageId') || '',
};

const villageSlice = createSlice({
  name: 'village',
  initialState,
  reducers: {
    setSelectedVillageId: (state, action) => {
      state.selectedVillageId = action.payload;
      localStorage.setItem('VillageId', action.payload); // Save to localStorage
    },
  },
});

export const { setSelectedVillageId } = villageSlice.actions;
export default villageSlice.reducer;
     